import { useEasyCounter, usePerformance } from "@crab/veekd"
import Cookie from 'js-cookie'
import client from '@/client/modules/coupon'

const tryno = Cookie.get('tryno') || undefined
export function reportPerformance() {
  const client = useEasyCounter()
  client.count('pdfvip_browser_page_view', 1, { ...tryno })
  // @ts-ignore
  window.addOnloadCallback(() => {
    const res = usePerformance()
    client.gauge('pdfvip_fp', res.fp, { ...tryno })
    client.gauge('pdfvip_fcp', res.fcp, { ...tryno })
    client.gauge('pdfvip_tti', res.tti, { ...tryno })
  })
}

export function easyCounterReport(name: string) {
  try {
    useEasyCounter().count(name, 1, { tryno })
  } catch (error) {
    console.error(' == 上报错误 == ', error)
  }
}

// 米大师支付上报 - 报表：duba_newvip_ab
export function reportMidasPay(data: object) {
  try {
    const existingOpenids = Cookie.get('dubaNewVipAb_openid')
    let openidArray = []

    if (existingOpenids) {
      try {
        openidArray = JSON.parse(existingOpenids)
        if (!Array.isArray(openidArray)) {
          openidArray = [openidArray]
        }
      } catch (e) {
        openidArray = [existingOpenids]
        console.error(' == 解析 dubaNewVipAb_openid 错误 == ', e)
      }
    }

    // @ts-ignore
    const { openid = 0, act_name = '', curver = 0 } = data
    const currentUser = `${openid}_${act_name}_${curver}`
    // @ts-ignore
    if (!openidArray.includes(currentUser)) {
      // @ts-ignore
      openidArray.push(currentUser)
      Cookie.set('dubaNewVipAb_openid', JSON.stringify(openidArray))
      client.REPORT.reportabTestKfmt(data)
    }
  } catch (error) {
    console.error(' == 上报错误 == ', error)
  }
}